function CurriculumCard({
  title,
  description,
  children,
  icon: Icon,
  iconClassName = "flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50 text-blue-600",
  className = "",
}) {
  const renderIcon = () => {
    if (!Icon) return null;

    if (typeof Icon === "string") {
      return (
        <img
          src={Icon}
          alt={title}
          className="h-14 w-14"
        />
      );
    }

    return (
      <div className={iconClassName}>
        <Icon className="h-6 w-6" />
      </div>
    );
  };

  return (
    <article
      className={`
        group
        rounded-2xl
        border
        border-slate-200
        bg-white
        p-6
        transition-all
        duration-300
        hover:-translate-y-1
        hover:border-blue-200
        hover:shadow-xl
        ${className}
      `}
    >
      <div className="flex items-start">{renderIcon()}</div>
      <h3 className="mt-5 md:text-2xl text-xl font-bold text-[#12105E]">
        {title}
      </h3>

      <p className="mt-3 leading-7 text-slate-500">{description}</p>

      {children}
    </article>
  );
}

export default CurriculumCard;
